export default __webpack_public_path__ + "static/media/original.779bf647.svg";